import api from './api';

export const engineeringService = {
  // engineeringService.js
getEngineeringByProjectId: async (projectId, token) => {
  try {
    const headers = { Authorization: `Bearer ${token}` };
   
    const response = await api.get(`/engineering/project/${projectId}/`, { headers });
    
    // A resposta agora é uma lista (ListAPIView), pegue o primeiro item
    const engineeringList = response.data;
    
    if (!engineeringList || engineeringList.length === 0) {
      throw new Error('Engineering não encontrado para este project_id');
    }
    
    // Retorna o primeiro resultado (ou você pode retornar a lista toda)
    return engineeringList[0];
  } catch (error) {
    console.error('❌ Erro ao buscar por project_id:', error);
    throw error;
  }
},

  getEngineeringById: async (matchObjectId, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.get(`/engineering/${matchObjectId}/`, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar dados de engenharia:', error);
      throw error;
    }
  },

  updateEngineering: async (matchObjectId, formData, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.put(`/engineering/${matchObjectId}/update/`, formData, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar dados de engenharia:', error);
      throw error;
    }
  },
};
